<template>
  <van-popup class="popup-luck" v-model="isShowLuckResultPop">
    <div class="luck-container" :class="[{'noLuck-container-big': awardInfo.type == 0}]">
      <!-- 实物 1-->
      <div v-if="awardInfo.type == 1" class="shiwu">
        <div class="gongxi">
          <span class="tip">恭喜您获得{{ awardInfo.name }}</span>
          <p class="shiwu_name" @click="goMyRecord">请到我的奖品填写收货物地址</p>
        </div>
        <img class="img shiwu_img" :src="awardInfo.pic" />
        <button class="btn_share" @click="sharePoster">{{btnDesc}}</button>
        <p class="desc">{{desc || '分享到朋友圈更容易中奖哦'}}</p>
      </div>
      <!-- 金币 5-->
      <div v-if="awardInfo.type == 5" class="course">
        <div class="gongxi">
          <div class="tip">恭喜您获得{{ awardInfo.name }}</div>
          <p class="shiwu_name">请到学而思网校app-我的-金币商城中查看</p>
        </div>
        <img class="img shiwu_img" :src="awardInfo.pic" />
        <button class="btn_share" @click="sharePoster">{{btnDesc}}</button>
        <p class="desc">{{desc || '分享到朋友圈更容易中奖哦'}}</p>
      </div>
      <!-- 赠课卡3 -->
      <div v-if="awardInfo.type == 3" class="course">
        <div class="gongxi">
          <div class="tip">恭喜您获得{{ awardInfo.name }}</div>
          <p class="shiwu_name">请到学而思网校app-学习-录播课查看</p>
        </div>
        <img class="img shiwu_img" :src="awardInfo.pic" />
        <button class="btn_share" @click="sharePoster">{{btnDesc}}</button>
        <p class="desc">{{desc || '分享到朋友圈更容易中奖哦'}}</p>
      </div>
      <!-- 其他：全部认为未中奖 -->
      <div v-if="awardInfo.type == 0" class="noLuck">
        <div class="gongxi">
          <div class="tip">很遗憾 未中奖哦～</div>
          <p class="shiwu_name">邀好友参与活动可提升中大奖概率哦～</p>
        </div>
        <img class="img shiwu_img" :src="noLuck" />
        <button class="btn_share" @click="sharePoster">{{offline ? '开心得收下' : '去分享'}}</button>
      </div>
    </div>
    <div class="close" @click="isShowLuckResultPop=false"></div>
  </van-popup>
</template>

<script>
// import { isApp } from '../../common/utils/xesFunction.js'
import { mapState } from 'vuex'
import { MYPRIZEPAGE, SHARE } from '../const'
export default {
  data() {
    return {
      isShowLuckResultPop: false,
      noLuck: 'https://editor.xesimg.com/tailor/resource/noluck-1622638555294.png'
      // awardInfo: {}
    }
  },
  computed: {
    ...mapState([
      'sGroupId'
    ]),
    btnDesc() {
      return this.offline ? '开心得收下' : '分享再抽一次'
    }
  },
  props: {
    awardInfo: {
      type: Object,
      default: () => { return {} }
    },
    userId: {
      type: String
    },
    desc: {
      type: String
    },
    offline: {
      type: Boolean
    }
  },
  watch: {
    // award: {
    //   handler(value) {
    //     console.log('f', value)
    //     this.awardInfo = value
    //   },
    //   deep: true
    // },
    userId(val) {
      if (val) {
        this.userId = val
      }
    }

  },
  methods: {
    // 我的奖品
    goMyRecord() {
      window.location.href = `${MYPRIZEPAGE}?sGroupId=${this.sGroupId}&userId=${this.userId || ''}`
    },
    // 分享
    sharePoster() {
      //
      this.isShowLuckResultPop = false
      this.$xesLogger.clickMsg({
        params: {
          clickid: 20,
          action: 'click',
          elemname: '点击分享海报'
        }
      })
      if (this.offline) {
        return
      }
      const tal_token = this.$xesCookie.get('tal_token')
      const URL = `${SHARE}?sourceId=${this.sourceId}&tal_token=${tal_token}&titleBarType=2`
      setTimeout(() => {
        location.href = URL
      }, 300)
    }
  }
}
</script>

<style lang="less" scoped>
.popup-luck.van-popup {
  overflow-y: unset !important;
  background-color: transparent;
}

div.noLuck-container-big {
  height: 277px;
}

.close {
  position: absolute;
  top: -13px;
  right: -13px;
  width: 27px;
  height: 27px;
  background: url(../assets/images/guanbi.png) no-repeat;
  background-size: cover;
}

.luck-container {
  position: relative;
  box-sizing: border-box;
  width: 590px/2;
  height: 596px/2;
  overflow: hidden;
  text-align: center;
  background: #fff;
  border-radius: 10px;

  .gongxi {
    margin: 0 auto;
    text-align: center;

    .tip {
      height: 18px;
      font-size: 18px;
      font-weight: 600;
      font-family: PingFangSC-Medium;
      line-height: 18px;
      color: #cd4025;
    }

    .shiwu_name {
      padding-top: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      color: #933916;
    }
  }

  .img {
    width: 129px;
    height: 126px;
    margin: 11px auto 0;
  }

  .desc {
    font-size: 24px/2;
    font-weight: 400;
    font-family: PingFang SC;
    line-height: 48px/2;
    text-align: center;
    color: #acacac;
  }

  .btn_share {
    width: 440px/2;
    height: 35px;
    margin-top: 10px;
    font-weight: bold;
    color: white;
    background: linear-gradient(-69deg, #e42225 0%, #ed4351 99%);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 35px/2;
  }

  .shiwu {
    padding-top: 66px/2;
  }

  .course {
    padding-top: 66px/2;
  }

  .quan {
    padding-top: 66px/2;
  }

  .noLuck {
    padding-top: 66px/2;
  }
}
</style>
